/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DayOfWeek } from './DayOfWeek';
import {
    DayOfWeekFromJSON,
    DayOfWeekFromJSONTyped,
    DayOfWeekToJSON,
    DayOfWeekToJSONTyped,
} from './DayOfWeek';

/**
 * 
 * @export
 * @interface DutyPreferenceResponse
 */
export interface DutyPreferenceResponse {
    /**
     * 
     * @type {DayOfWeek}
     * @memberof DutyPreferenceResponse
     */
    weekday: DayOfWeek;
    /**
     * 
     * @type {boolean}
     * @memberof DutyPreferenceResponse
     */
    aw12: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DutyPreferenceResponse
     */
    aw3: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DutyPreferenceResponse
     */
    bg: boolean;
}



/**
 * Check if a given object implements the DutyPreferenceResponse interface.
 */
export function instanceOfDutyPreferenceResponse(value: object): value is DutyPreferenceResponse {
    if (!('weekday' in value) || value['weekday'] === undefined) return false;
    if (!('aw12' in value) || value['aw12'] === undefined) return false;
    if (!('aw3' in value) || value['aw3'] === undefined) return false;
    if (!('bg' in value) || value['bg'] === undefined) return false;
    return true;
}

export function DutyPreferenceResponseFromJSON(json: any): DutyPreferenceResponse {
    return DutyPreferenceResponseFromJSONTyped(json, false);
}

export function DutyPreferenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyPreferenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'weekday': DayOfWeekFromJSON(json['weekday']),
        'aw12': json['aw12'],
        'aw3': json['aw3'],
        'bg': json['bg'],
    };
}

export function DutyPreferenceResponseToJSON(json: any): DutyPreferenceResponse {
    return DutyPreferenceResponseToJSONTyped(json, false);
}

export function DutyPreferenceResponseToJSONTyped(value?: DutyPreferenceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weekday': DayOfWeekToJSON(value['weekday']),
        'aw12': value['aw12'],
        'aw3': value['aw3'],
        'bg': value['bg'],
    };
}

